import { render, staticRenderFns } from "./RegistrationList.vue?vue&type=template&id=bc03b112&scoped=true"
import script from "./RegistrationList.vue?vue&type=script&lang=js"
export * from "./RegistrationList.vue?vue&type=script&lang=js"
import style0 from "./RegistrationList.vue?vue&type=style&index=0&id=bc03b112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc03b112",
  null
  
)

export default component.exports